import { SectionTitle } from '@/components/shared/Content';
import { Box, Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import styled from 'styled-components';

export const CoverageTitle = styled(SectionTitle)`
  ${MEDIA_QUERIES.tabletAndDesktop`
        ${font('main', {
          fontSize: '4.4rem',
          lineHeight: '5.6rem',
          fontWeight: 'bold',
        })}
    `}
`;

export const CoverageSubtitle = styled(Box)`
  ${font('main', { fontSize: '2.0rem', lineHeight: '2.8rem' })}
  text-align: center;
  margin: 20px 46px 28px;

  ${MEDIA_QUERIES.tabletAndDesktop`
        ${font('main', { fontSize: '1.8rem', lineHeight: '2.8rem' })}
        margin: 20px 26px 58px;
    `}
`;

export const CoverageItem = styled(Flex)`
  position: relative;
  width: 100%;
  align-items: center;

  ${MEDIA_QUERIES.mobile`
        margin-bottom: 26px;

        &:last-child {
            margin-bottom: 0;
        }
    `}

  ${MEDIA_QUERIES.tabletAndDesktop`
        flex-direction: column;
        flex: 0 1 366px;
    `}
`;

export const CoverageItemImage = styled(Flex)`
  min-width: 68px;
  height: 68px;
  background-image: url(${({ background }) => background});
  background-size: contain;

  ${MEDIA_QUERIES.mobile`
        margin-right: 14px;
    `}

  ${MEDIA_QUERIES.tabletAndDesktop`
        min-width: 165px;
        height: 165px;
        background-image: url(${({ backgroundDesktop, background }) => backgroundDesktop || background});
    `}
`;

export const CoverageItemInfo = styled(Flex)`
  flex-direction: column;

  ${MEDIA_QUERIES.tabletAndDesktop`
        align-items: center;
    `}
`;

export const CoverageItemTitle = styled(Flex)`
  margin-bottom: 7px;
  width: 93%;

  ${MEDIA_QUERIES.tabletAndDesktop`
        justify-content: center;
        margin-top: 25px;
        margin-bottom: 11px;
        width: 100%;
    `}
`;

export const CoverageItemDescription = styled(Flex)`
  width: 240px;

  ${MEDIA_QUERIES.tablet`
        justify-content: center;
        width: 256px;
    `}

  ${MEDIA_QUERIES.desktop`
        justify-content: center;
        width: 226px;
    `}
`;
